<template>
  <div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      earthIsLoaded: false
    }
  },
  mounted () {
    this.earthIsLoaded = false

    var w = window
    // Get the first script element on the page
    var ref = w.document.getElementsByTagName('script')[0]

    // Create a new script element
    var script = w.document.createElement('script')

    // Set the script element `src`
    script.src = 'https://www.webglearth.com/v2/api.js'

    // Inject the script into the DOM
    ref.parentNode.insertBefore(script, ref)

    let timer = 0
    timer = setInterval(() => {
      if (window.WE) {
        this.earthIsLoaded = true
        this.$nextTick(() => {
          this.$emit('ready')
        })
        clearInterval(timer)
      }
    })
  }
}
</script>

<style>

</style>
